import { render } from "./CommentTab.vue?vue&type=template&id=162a52db"
import script from "./CommentTab.vue?vue&type=script&lang=js"
export * from "./CommentTab.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__